import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/quote/quote-content.jsx");
